export default __webpack_public_path__ + "static/media/name-that-app-thumb.47aca155.jpg";